import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient"
import { PaginationResponse, ResponseData } from "./types/_public";
import { IFacility } from "./types/_facility";

const api = new APIClient();

const path = '/facilities';

const facilitiesApi = {
  facilities(params: any): Promise<AxiosResponse<ResponseData<IFacility[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },

  getFacility(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  
  deleteFacility(id: any) {
    return api.delete(`${path}/${id}`);
  },
  
  postFacility(dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putFacility(id: string | number, dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/${id}`;
    return api.put(url, dataForm)
  },

  updateFacilityBarStatus(dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/update-bar-status`;
    return api.put(url, dataForm)
  }
}

export default facilitiesApi
